import api from "api";
import { useMutation } from "react-query";
import { useId } from "utils/hooks";

const useDeleteReferral = () => {
  const patientId = useId();
  return useMutation((id: number) => api("DELETE /patients/{patient_id}/medical_referrals/{id}", [patientId, id]));
};

export default useDeleteReferral;
